// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"124":"fa8e7abc","332":"fb816e9e"}[chunkId] + ".css";
};